import { checkIsValidAreaCodes } from "./checkIsValidAreaCodes";

export const areaCodesValidator = (x, value: string) => {
  const endsWithDash = value.endsWith("-");
  if (checkIsValidAreaCodes(value) && !endsWithDash) {
    return Promise.resolve();
  }
  return Promise.reject();
};
